import Book from "@mui/icons-material/Book";
import FolderCopy from "@mui/icons-material/FolderCopy";
import Help from "@mui/icons-material/Help";
import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import Settings from "@mui/icons-material/Settings";
import Workspaces from "@mui/icons-material/Workspaces";
import Chip from "@mui/material/Chip";
import React from "react";
import useSession, { Session } from "../useSession/useSession";
import { useNonNullableContext } from "../utils/nonNullableContext";
import { Navigation } from "./navigation";

const NavigationContext = React.createContext<{
  navigation: Navigation;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}>({ navigation: [], isExpanded: false, setIsExpanded: () => {} });

function getNavigation(session: Session | undefined) {
  let navigation = [] as Navigation;
  if (Object.keys(session?.roles ?? {}).length > 0) {
    navigation.push({
      segment: "workspaces",
      title: "Mes espaces de travail",
      icon: <Workspaces style={{ color: "black" }} />,
    });
  }
  if ((session?.OrionUserGroups ?? []).length > 0) {
    navigation.push(
      {
        kind: "header",
        title: "Orion",
      },
      {
        kind: "divider",
      },

      {
        segment: "orion/assets",
        title: "Dossiers",
        icon: <FolderCopy style={{ color: "black" }} />,
      }
    );
    if ((session?.OrionContributorGroups ?? []).length > 0) {
      navigation.push(
        {
          segment: "orion/configs",
          title: "Configurations",
          icon: <Settings style={{ color: "black" }} />,
        },
        {
          segment: "orion/api",
          title: "Documentation",
          icon: <Help style={{ color: "black" }} />,
          action: <Chip label="Coming Soon" color="secondary" size="small" />,
        }
      );
    }
  }
  if ((session?.SiriusUserGroups?.length ?? 0) > 0) {
    navigation.push(
      {
        kind: "header",
        title: "Sirius",
      },
      {
        kind: "divider",
      },
      {
        segment: "sirius/bots",
        title: "Agents",
        icon: <QuestionAnswer style={{ color: "black" }} />,
      },
      {
        segment: "sirius/connectors",
        title: "Ma documentation",
        icon: <Book style={{ color: "black" }} />,
        action: <Chip label="Coming Soon" color="secondary" size="small" />,
      }
    );
  }
  return navigation;
}

export const NavigationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(true);
  const session = useSession();
  const navigation = getNavigation(session);
  return (
    <NavigationContext.Provider
      value={{ navigation, isExpanded, setIsExpanded }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () =>
  useNonNullableContext(NavigationContext, "Navigation");
